window.addEventListener('alpine:init', () => {
  if (window.global.registeredAlpineComponents['professionalsForm']) return;

  function professionalsForm(data = {}) {
    return {
      ...data,

      isLoading: false,

      isNpiValid: false,

      init() {
        this.onFormSubmit = this.onFormSubmit.bind(this);
      },

      destroy() {
        if (this.formEl) {
          this.formEl.removeEventListener('submit', this.onFormSubmit);
        }
      },

      onReady() {
        this.formEl = this.$el.querySelector('form');

        if (!this.formEl) return;

        this.npiEl = [...this.$el.querySelectorAll('.globo-form-control')].find((el) => el.innerText.includes('NPI'));

        this.npiInputEl = this.npiEl.querySelector('input');

        this.npiErrorEl = this.npiEl.querySelector('.messages');

        this.formEl.addEventListener('submit', this.onFormSubmit);
      },

      onFormSubmit(event) {
        if (this.isNpiValid) return;

        event.stopImmediatePropagation();
        event.preventDefault();

        this.isLoading = true;

        var npiInputValue = this.npiInputEl.value.trim();

        var url = new URL('https://clinicaltables.nlm.nih.gov/api/npi_idv/v3/search');

        url.searchParams.set('terms', npiInputValue);

        fetch(url)
          .then((res) => res.json())
          .then((res) => {
            this.isNpiValid = res[1].includes(npiInputValue);

            if (this.isNpiValid) {
              this.formEl.requestSubmit();
              this.isNpiValid = false;
            } else {
              setTimeout(() => this.onNpiInvalid());
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      },

      onNpiInvalid() {
        this.npiEl.scrollIntoView({ block: 'center' });

        this.npiEl.classList.add('has-error');

        this.npiErrorEl.innerHTML = `
          <p class="help-block error">
            ${window.global.translate.professionals_form.npi_error}
          </p>
        `;
      }
    };
  };

  Alpine.data('professionalsForm', professionalsForm);

  window.global.registeredAlpineComponents['professionalsForm'] = true;
});
